export class RdsNativePitrClusterAdvancedConfig {
    'encryptionKeyId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "encryptionKeyId",
            "baseName": "encryptionKeyId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RdsNativePitrClusterAdvancedConfig.attributeTypeMap;
    }
    constructor() {
    }
}
